import { Component, Renderer2, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ImpersonationService } from '../core/impersonation-service';
import { UIBlockingService } from '../core/ui-blocking.service';

@Component({
  selector: 'app-public-portal-base',
  templateUrl: './public-portal-base.component.html',
  styleUrls: ["../../../node_modules/@mobiscroll/angular/dist/css/mobiscroll.min.css",
    "../../assets/js/plugins/datatables/datatables.min.css",
    "../../assets/js/plugins/fontawesome/all.css",
    "../../../node_modules/ngx-toastr/toastr.css",
    "../../assets/css/public.css",
    "../../assets/css/overrides.css"],
  encapsulation: ViewEncapsulation.None
})
export class PublicPortalBaseComponent {
  hideHeader = false;
  onNewsPage = false;
  onDirectory = false;
  impersonating = false;
  impersonatedContactName = "";

  constructor(private router: Router,
    private renderer: Renderer2, private impersonationService: ImpersonationService, private blockUI: UIBlockingService) {
    router.events.subscribe((event) => (event instanceof NavigationEnd) && this.handleRouteChange());
  }

  ngOnInit() {
    this.handleRouteChange()
  }
  handleRouteChange = () => {
    this.impersonating = localStorage.getItem("impersonating") == "true";
    this.impersonatedContactName = localStorage.getItem("impersonatedContactName");
    if (this.router.url.includes('member-news')) {
      this.onNewsPage = true;
    };
    if (this.router.url.includes('member-directory')) {
      this.onDirectory = true;
    };
  }

  endImpersonation(): void {
    if (this.impersonating) {
      this.blockUI.start();
      this.impersonationService.endImpersonation().subscribe({
        next: (status) => {
          this.impersonationService.impersonationStatus.next(status);
          localStorage.setItem('userFirstName', status.userFirstName);
          localStorage.setItem('userLastName', status.userLastName);
          localStorage.setItem('contactId', status.contactId);
          localStorage.setItem('contactType', status.contactType);
          localStorage.setItem('userEmailAddress', status.userEmailAddress);
          localStorage.setItem('impersonating', "false");

          this.router.navigate(['/admin-portal/chamber/super-admin-management']).then(() => {
            this.blockUI.stop();
          });
        },
      });
    }
  }
}
